import './footer.css'
import Icon from '@mdi/react';
import { mdiFacebook, mdiInstagram, mdiLinkedin, mdiTwitter, mdiYoutube } from '@mdi/js';
import { Link, useNavigate } from 'react-router-dom';

export default function Footer(){

    const navigate = useNavigate();

    const irParaPrecos = () => {
      navigate("/", { state: { scrollToPlanos: true } });
    };

    const irParaFAQ = () => {
      navigate("/", { state: { scrollToFAQ: true } });
    };

    return(
        <div className='footer_footer-base'>
            <div className='footer_column'>
                <h1>Páginas</h1>
                <div className='footer_list-items'>
                    <Link to='/'>Início</Link>
                    <Link to='/Sobre'>Sobre</Link>
                    <a onClick={irParaPrecos} style={{cursor:'pointer'}}>Adquira relatórios</a>

                </div>
            </div>
            <div className='footer_column'>
                <h1>Redes Sociais</h1>
                <div className='footer_list-items'>
                    <a href='https://www.instagram.com/melocalizae/' target='_blank'><Icon path={mdiInstagram} size={1} /> Instagram</a>
                </div>
            </div>
            <div className='footer_column'>
                <h1>Demais informações</h1>
                <div className='footer_list-items'>
                    <a href='/FaleConosco'>Fale Conosco</a>
                    <a onClick={irParaFAQ} style={{cursor:'pointer'}}>Perguntas frequentes</a>
                    <Link to='/TermosDeUso'>Termos de Uso</Link>
                    <Link to='/PoliticaPrivacidade'>Políticas de Privacidade</Link>
                </div>
            </div>

        </div>
    )
}